export default async function fetchPosts(p = {}) {
  const {
    postType = "blog",
    postsPerPage = 5,
    offset = 0,
    acfFields = [],
    action,
  } = p;

  const req = await fetch(params.ajax_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      action: action,
      postType,
      postsPerPage,
      offset,
      acfFields: JSON.stringify(acfFields), // Передаємо масив назв полів
    }),
  });

  let res;
  if (req.ok) {
    res = await req.json();
  } else {
    res = { error: req.statusText };
  }

  // Якщо відповідь успішна, повертаємо дані
  return res;
}
